/**
 * Make every id declared inside an svg content string unique to one render
 * instance and rewrite the references to it (url(#id), href="#id").
 *
 * Masks, clipPaths, patterns and gradients carried inside svgContent collide
 * when the same overlay is drawn more than once in one document (editor
 * canvas, thumbnail strip, layer-list preview, hidden measurement copies):
 * url(#id) resolves to the FIRST matching id in the document, and a mask that
 * lives in a hidden copy masks the visible shape away entirely.
 */
export function namespaceSvgIds(svgContent: string, suffix: string): string {
  const ids = new Set<string>();
  for (const m of svgContent.matchAll(/\sid="([^"]+)"/g)) ids.add(m[1]);
  if (!ids.size) return svgContent;
  let out = svgContent;
  for (const oldId of ids) {
    const esc = oldId.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const newId = `${oldId}-${suffix}`;
    out = out
      .replace(new RegExp(`(\\sid=")${esc}(")`, "g"), `$1${newId}$2`)
      .replace(new RegExp(`url\\(#${esc}\\)`, "g"), `url(#${newId})`)
      .replace(new RegExp(`(href=")#${esc}(")`, "g"), `$1#${newId}$2`);
  }
  return out;
}
